// A webinar's 16:9 thumbnail, as the Library's cards, Free webinars' cards and the admin preview draw
// it: Adam's own design, filling the frame, or, where there's none, or it won't load, a light grey
// panel with the card's date block in the middle (children), so cards side by side keep 1 height.
// Staff viewing as a member see the member's own (Adam, 10 Oct). While the link is being signed the
// panel shows empty, so the date doesn't flash up before the picture. The picture is decorative
// (alt=""), and so is the date panel (aria-hidden): the card's own words say what it is and when. It
// loads at once, never lazily, since a card is on the screen when it's drawn. Spans all the way down,
// since a Library card is a link.
// onError and onLoad go to free/thumbnails.js, with the link.
export function ThumbnailFrame({ thumb, onError, onLoad, className = '', children }) {
  const { url = null, pending = false } = thumb || {}
  return (
    <span className={`thumb${className ? ` ${className}` : ''}`}>
      {url && <img key={url} className="thumb-img" src={url} alt="" decoding="async" onError={onError} onLoad={onLoad} />}
      {!url && !pending && <span className="thumb-fallback" aria-hidden="true">{children}</span>}
    </span>
  )
}
